import tonStyles from './ton.json'
import mediaQuery from './mediaQuery'
import * as theme from './ton/index'
import motionSpecs from './motionSpecs'
import breakpoints from './breakpoints';

export default {
  direction: 'ltr',
  typography: tonStyles,
  baseOverrides: theme.baseOverrides,
  breakpoints,
  spacingMultiplier: 8,
  rowOffsetTopSmall: 3,
  rowOffsetTopMedium: 4,
  rowOffsetTopLarge: 6,
  rowOffsetTopXLarge: 6,
  fullBleed: false,
  mediaQuery,
  motionSpecs,
  custom: theme
}
